
export const checkCompanyInfo = (companyInfoObject, type="new employer") => {
    let companyInfo = companyInfoObject?.company;

    if (!companyInfo){
        return true;
    }

    let infoToCheck = [];
    infoToCheck = ["companyName", "invoiceEmail", "rcNumber", "tinNumber", "address", "payrollCutOff", "withdrawalPercent", "autoWithdrawals", "salaryAccountNumber", "salaryBankName"];
    
    if (type === "existing employer"){
        infoToCheck = ["companyName", "invoiceEmail", "rcNumber", "tinNumber", "address", "payrollCutOff", "withdrawalPercent", "autoWithdrawals"];
    }
    
    let companyInfoFilled = true;

    for (let info = 0; info < infoToCheck.length; info++) {
        if (!(infoToCheck[info] in companyInfo)) {
            companyInfoFilled = false;
            // console.log(infoToCheck[info] , "is absent");
        }
        else {
            // console.log(infoToCheck[info] , "is present");
        }
    }

    Object.keys(companyInfo).forEach(function (key) {
        // console.log("key",key);
        if (infoToCheck.indexOf(key) >= 0) {
            if (companyInfo[key] === "" || companyInfo[key] === null || companyInfo[key] === undefined) {
                // console.log(companyInfo[key], "is empty");
                companyInfoFilled = false;
            }
        }
    });

    return (companyInfoFilled);
};

export default checkCompanyInfo;